<template>
  <div>
    <main>
      <v-container grid-list-xl class="content-header">
          <v-flex xs12 sm10 offset-sm1>
            <v-layout column>
              <v-flex xs12 class="text-xs-center">
                  <div class="error-page">
                    <h1 class="hudge">404</h1>
                    <span class="grey--text error-massage">Page not found!</span>
                    <p>Click <router-link tag="a" :to="{ name: 'currentEvent' }">here</router-link> to go back</p>
                  </div>
              </v-flex>
            </v-layout>
          </v-flex>
      </v-container>
    </main>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped lang="scss">
  main {
    height: 100vh;
    display: flex;
    align-items: center;
  }
  .error-page {
    width: 100%;
    background-color: #fff;
    padding: 30px 20px 40px;
    position: relative;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 
                0 1px 1px 0 rgba(0,0,0,.14), 
                0 1px 3px 0 rgba(0,0,0,.12);
  }
  .hudge {
    font-size: 8em !important;
    text-align: center;
  }
  .error-massage {
    font-size: 2em !important;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/404.vue